const property = [
    {
        id: '#TBS01',
        type: 'Villa',
        img: 'assets/images/real-estate/img-01.jpg',
        name: 'The Country House',
        address: 'United Kingdom',
        agentname: 'Josefa Weissnat',
        price: '$2451.39',
        status: 'Sale'
    },
    {
        id: '#TBS02',
        type: 'Residency',
        img: 'assets/images/real-estate/img-02.jpg',
        name: 'Classic White House',
        address: 'Germany',
        agentname: 'Jerry Emard',
        price: '$2451.20',
        status: 'Rent'
    },
    {
        id: '#TBS03',
        type: 'Apartment',
        img: 'assets/images/real-estate/img-03.jpg',
        name: 'Vintage Apartment',
        address: 'Brazil',
        agentname: 'Domenic Dach',
        price: '$1249.99',
        status: 'Rent'
    },
    {
        id: '#TBS04',
        type: 'Villa',
        img: 'assets/images/real-estate/img-04.jpg',
        name: 'Whitespace Vintage Villa',
        address: 'Spain',
        agentname: 'Axel Kozey',
        price: '$3495.76',
        status: 'Sale'
    },
    {
        id: '#TBS05',
        type: 'Residency',
        img: 'assets/images/real-estate/img-05.jpg',
        name: 'Duplex Square Valley',
        address: 'Mexico',
        agentname: 'Buck Roberts',
        price: '$2579.31',
        status: 'Rent'
    },
    {
        id: '#TBS06',
        type: 'Residency',
        img: 'assets/images/real-estate/img-06.jpg',
        name: 'Small Grey Brick Home In A Subdivision',
        address: 'USA',
        agentname: 'Josefa Weissnat',
        price: '$1478.00',
        status: 'Sale'
    }
]

const feedback = [
    {
        id: '1',
        img: 'assets/images/users/48/avatar-2.jpg',
        name: 'Josefa Weissnat',
        content: " Themebrand used AnyDesk to fix the bug in Flask and django version. I highly recommend this product! ",
        time: '04:47 PM'
    },
    {
        id: '2',
        img: 'assets/images/users/48/avatar-3.jpg',
        name: 'Ophelia Steuber',
        content: "  Thank you for this awesome admin panel. I'm very happy with it, it's a pleasure to work with it! ",
        time: '11:24 AM'
    },
    {
        id: '3',
        img: 'assets/images/users/48/avatar-4.jpg',
        name: 'Dianna Bogan',
        content: " High theme quality. Very good support, they spent almost an hour remotely to fix a problem. I hope this theme will have a long term support. ",
        time: '03:19 PM'
    },
    {
        id: '4',
        img: 'assets/images/users/48/avatar-5.jpg',
        name: 'Jerry Emard',
        content: " There is as lot packed in this template. The savings in time and energy is so worth it. ",
        time: '06:39 AM'
    },
    {
        id: '5',
        img: 'assets/images/users/48/avatar-6.jpg',
        name: 'Axel Kozey',
        content: " Works like a component library, a crazy amount of design elements already built and given. ",
        time: '09:18 AM'
    }
]

const saleproperty = [
    {
        id: '1',
        img: 'assets/images/real-estate/img-08.jpg',
        name: 'Crystal House',
        bedroom: '2',
        bathroom: '1',
        sqft: '1039',
        rate: '4.5'
    },
    {
        id: '2',
        img: 'assets/images/real-estate/img-07.jpg',
        name: 'Whitespace Vintage Villa',
        bedroom: '4',
        bathroom: '2',
        sqft: '1145',
        rate: '4.9'
    },
    {
        id: '3',
        img: 'assets/images/real-estate/img-05.jpg',
        name: 'Northlight Residency',
        bedroom: '3',
        bathroom: '3',
        sqft: '1859',
        rate: '4.7'
    },
    {
        id: '4',
        img: 'assets/images/real-estate/img-08.jpg',
        name: 'Park Side Colonial',
        bedroom: '5',
        bathroom: '3',
        sqft: '5643',
        rate: '4.7'
    },
    {
        id: '5',
        img: 'assets/images/real-estate/img-04.jpg',
        name: 'Marina Hill Vintage',
        bedroom: '4',
        bathroom: '3',
        sqft: '1963',
        rate: '4.8'
    },
    {
        id: '6',
        img: 'assets/images/real-estate/img-07.jpg',
        name: 'Grand Cub Hotel',
        bedroom: '3',
        bathroom: '1',
        sqft: '1543',
        rate: '4.4'
    },
    {
        id: '7',
        img: 'assets/images/real-estate/img-03.jpg',
        name: 'Evergreen Villa with Residency',
        bedroom: '5',
        bathroom: '3',
        sqft: '3652',
        rate: '4.5'
    }
]

const rentproperty = [
    {
        id: '1',
        img: 'assets/images/real-estate/img-01.jpg',
        name: 'Liberty Property',
        bedroom: '1',
        bathroom: '1',
        sqft: '958',
        rate: '4.3'
    },
    {
        id: '2',
        img: 'assets/images/real-estate/img-02.jpg',
        name: 'Duplex Square Valley',
        bedroom: '3',
        bathroom: '2',
        sqft: '2659',
        rate: '3.8'
    },
    {
        id: '3',
        img: 'assets/images/real-estate/img-03.jpg',
        name: "Small house on an autumn’s",
        bedroom: '2',
        bathroom: '1',
        sqft: '2230',
        rate: '4.3'
    },
    {
        id: '4',
        img: 'assets/images/real-estate/img-07.jpg',
        name: 'New Grand Hotel Room',
        bedroom: '3',
        bathroom: '2',
        sqft: '2785',
        rate: '4.9'
    },
    {
        id: '5',
        img: 'assets/images/real-estate/img-08.jpg',
        name: 'Park Side Colonial',
        bedroom: '5',
        bathroom: '3',
        sqft: '5643',
        rate: '4.7'
    },
    {
        id: '6',
        img: 'assets/images/real-estate/img-07.jpg',
        name: 'Whitespace Vintage Villa',
        bedroom: '4',
        bathroom: '2',
        sqft: '1145',
        rate: '4.9'
    },
    {
        id: '7',
        img: 'assets/images/real-estate/img-05.jpg',
        name: 'Nightlight Residency',
        bedroom: '2',
        bathroom: '1',
        sqft: '1324',
        rate: '4.9'
    }
]

const earningcard = [
    {
        id: 1,
        border: "secondary",
        iconColor: "success",
        icon: "ph-trend-up",
        ratting: "9.3",
        target: "798.97",
        letter: 'M',
        title: "Total Revenue",
        option: {
            startVal:0,
            useEasing: true,
            duration: 2,
            decimalPlaces: 2, 
        }
    },
    {
        id: 2,
        border: "primary",
        iconColor: "success",
        icon: "ph-trend-up",
        ratting: "20.8",
        target: "2356",
        letter: 'K',
        title: "Daily Earning",
        option: {
            startVal:0,
            useEasing: true,
            duration: 2,
        }
    },
    {
        id: 3,
        border: "warning",
        iconColor: "success",
        icon: "ph-trend-up",
        ratting: "12.6",
        target: "337.32",
        letter: 'M',
        title: "Total Balance",
        option: {
            startVal:0,
            useEasing: true,
            duration: 2,
            decimalPlaces: 2, 
        }
    }, {
        id: 4,
        border: "success",
        iconColor: "success",
        icon: "ph-trend-up",
        ratting: "18.7",
        target: "365.32",
        letter: 'M',
        title: "On hold",
        option: {
            startVal:0,
            useEasing: true,
            duration: 2,
            decimalPlaces: 2, 
        }
    }, {
        id: 5,
        border: "danger",
        iconColor: "danger",
        icon: "ph-trend-down",
        ratting: "7.1",
        target: "247.19",
        letter: 'M',
        title: "Expenses",
        option: {
            startVal:0,
            useEasing: true,
            duration: 2,
            decimalPlaces: 2, 
        }
    },
];
const earningdata = [
    {
        id: 1,
        icon: 'ph ph-trend-up',
        transactionID: '147852369012',
        date: '14 Nov, 2022 ',
        timestamp: '12:38PM',
        details: 'Membership Fees',
        type: 'Debit',
        amount: '236.41',
        status: 'Pending',
        color: 'danger'
    },
    {
        id: 2,
        icon: 'ph ph-trend-down',
        transactionID: '147852363645',
        date: '02 Jan, 2023  ',
        timestamp: '11:22PM',
        details: 'British Pound Sterling Block',
        type: 'Credit',
        amount: '875.32',
        status: 'Successful',
        color: 'success'
    },
    {
        id: 3,
        icon: 'ph ph-trend-down',
        transactionID: '147852362451',
        date: '27 Jan, 2023  ',
        timestamp: '03:19AM',
        details: 'Fashion T-Shirts Purchase',
        type: '   Credit',
        amount: '214.00',
        status: 'Successful',
        color: 'success'
    }, {
        id: 4,
        icon: 'ph ph-trend-down',
        transactionID: '147852315960',
        date: '28 Jan, 2023 ',
        timestamp: '05:36AM',
        details: 'The Country House',
        type: 'Credit',
        amount: '1470.50',
        status: 'Pending',
        color: 'success'
    }
    , {
        id: 5,
        icon: 'ph ph-trend-up',
        transactionID: '147852319632',
        date: '01 Feb, 2023 ',
        timestamp: '07:19PM',
        details: 'Vintage Apartment',
        type: 'Debit',
        amount: '3526.00',
        status: 'Successful',
        color: 'danger'
    }
    , {
        id: 6,
        icon: 'ph ph-trend-up',
        transactionID: '147852310391',
        date: '04 Feb, 2023  ',
        timestamp: '07:19PM',
        details: 'Duplex Square Valley',
        type: 'Debit',
        amount: '215.00',
        status: 'Successful',
        color: 'danger'
    }
    , {
        id: 7,
        icon: 'ph ph-trend-down',
        transactionID: '147852310298',
        date: '22 Feb, 2023 ',
        timestamp: '07:19PM',
        details: 'Crystal House',
        type: 'Credit',
        amount: '678.00',
        status: 'Cancelled',
        color: 'success'
    }
    , {
        id: 8,
        icon: 'ph ph-trend-up',
        transactionID: '147852310341',
        date: '12 Dec, 2022 ',
        timestamp: '01:57PM',
        details: 'Swimming pool side of the residential Ascot home.',
        type: 'Debit',
        amount: '1024.00',
        status: 'Successful',
        color: 'danger'
    }
    , {
        id: 9,
        icon: 'ph ph-trend-down',
        transactionID: '147852310003',
        date: '19 Dec, 2022',
        timestamp: '10:33AM',
        details: 'Small house on an autumn’s day',
        type: '  Credit',
        amount: '1024.00',
        status: 'Pending',
        color: 'success'
    }, {
        id: 10,
        icon: 'ph ph-trend-down',
        transactionID: '147852310298',
        date: '22 Feb, 2023 ',
        timestamp: '07:19PM',
        details: 'Crystal House',
        type: ' Credit',
        amount: '678.00',
        status: 'Cancelled',
        color: 'success'
    }
]


export { property, feedback, saleproperty, rentproperty, earningcard, earningdata }